import {FC} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {ticketPrefillFromWebInvoiceError} from '../../../ticket-management/ticket-create-context'
import {getWebFormEntryType} from '../core/invoiceAutoSend'
import {getInvoiceEntrySourceInfo} from '../core/invoiceEntrySourceHelpers'
import {Invoice, InvoiceTypeList} from '../core/_models'
import {useAuth} from '../../../../auth'
import {canUseTicketing} from '../../../../auth/core/ticketingAccess'

type Props = {
  errorMessage: string
  formType: number
  invoiceType: number
  invoiceTemplate: number
  invoiceNumber?: string
  invoice?: Invoice | null
  appLogId?: number
  onNavigate?: () => void
}

const invoiceTypeLabel = (invoiceType: number, invoiceTemplate: number) => {
  const type = InvoiceTypeList.find((item) => item.id === invoiceType)
  const template = type?.template?.find((item) => item.id === invoiceTemplate)
  return [type?.name, template?.name].filter(Boolean).join(' - ')
}

const WebInvoiceErrorSupportAction: FC<Props> = ({
  errorMessage,
  formType,
  invoiceType,
  invoiceTemplate,
  invoiceNumber,
  invoice,
  appLogId,
  onNavigate,
}) => {
  const {currentUser} = useAuth()
  const ticketingEnabled = canUseTicketing(currentUser)
  const navigate = useNavigate()
  const location = useLocation()
  const form = getInvoiceEntrySourceInfo(getWebFormEntryType(formType))
  const safePageUrl =
    typeof window === 'undefined'
      ? location.pathname
      : `${window.location.origin}${location.pathname}`

  const createTicket = () => {
    const prefill = ticketPrefillFromWebInvoiceError({
      errorMessage,
      formLabel: form.label,
      invoiceTypeLabel: invoiceTypeLabel(invoiceType, invoiceTemplate),
      invoiceNumber,
      invoiceId: invoice?.id,
      appLogId,
      operation: invoice?.id ? 'edit' : 'create',
      pageUrl: safePageUrl,
    })

    onNavigate?.()
    navigate('/apps/ticket-management/new', {
      state: {
        returnTo: `${location.pathname}${location.search}`,
        ticketPrefill: prefill,
      },
    })
  }

  return (
    <div className='w-100'>
      <p className='text-gray-600 fs-4 mb-6' style={{whiteSpace: 'pre-line'}}>
        {errorMessage}
      </p>
      {ticketingEnabled && (
        <>
          <button
            type='button'
            className='btn btn-light-danger'
            onClick={createTicket}
            aria-label='ثبت تیکت پشتیبانی برای خطای صدور صورتحساب'
          >
            <i className='las la-headset fs-3 me-1' aria-hidden='true'></i>
            ثبت تیکت پشتیبانی
          </button>
          <div className='text-gray-500 fs-8 mt-2'>
            نوع فرم و شرح این خطا به‌صورت خودکار به تیکت اضافه می‌شود.
          </div>
        </>
      )}
    </div>
  )
}

export {WebInvoiceErrorSupportAction, invoiceTypeLabel}
